import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import BillOfMaterialsAssetFormBody from "./BillOfMaterialsAssetFormBody";
import {BillOfMaterialsPreviewAsset} from "../../../../../model/job/BillOfMaterialsPreviewItems";
import BillOfMaterialsAssetForm from "./BillOfMaterialsAssetForm";
import {BomItem} from "../../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid
	 * @param {BillOfMaterialsPreviewAsset} bomAsset bill of materials asset data to update
	 */
	onSubmit: (bomAsset: BillOfMaterialsPreviewAsset) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Bill of materials asset to edit.
	 */
	bomAsset: BomItem;
}

type IState = BaseFormViewState<BillOfMaterialsAssetForm>;

export default class BillOfMaterialsAssetFormView extends BaseFormView<BillOfMaterialsAssetForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: BillOfMaterialsAssetForm.createFromBillOfMaterialsAsset(this.props.bomAsset),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<BillOfMaterialsAssetFormBody form={this.state.form}
											  onFieldChange={this.onFieldChanged}
											  onFieldCompleted={this.onFieldCompleted}
											  onFocusChange={this.onFocusChange}
											  onFieldsChange={this.onFieldsChanged}
											  bomAsset={this.props.bomAsset}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update Bill of Materials"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}
